import { useParams } from 'react-router-dom';

import { useGetDoc } from '@/api/queries/useGetDoc';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { Icon } from '@/new/components/icon';
import { PDFViewer } from '@/new/components/pdf-viewer';
import { DocumentTabs } from '@/new/components/reference-content/document-tabs';
import { DrawerErrorState } from '@/new/components/reference-content/drawer-error-state';

interface DocumentDrawerContentProps {
  docId: string;
  onClose?: () => void;
}

export function DocumentDrawerContent({ docId, onClose }: DocumentDrawerContentProps) {
  const { matterId } = useParams();
  const { data: matter, isLoading: isLoadingMatter } = useGetMatterV2(matterId);
  const subsetId = matter?.allDocumentsCaseId ?? undefined;
  const { data: doc, isLoading: isLoadingDoc, error } = useGetDoc(matterId, docId);

  return (
    <div className="flex h-full flex-col">
      {error ? (
        <DrawerErrorState label="document" />
      ) : (
        <>
          {(isLoadingMatter || isLoadingDoc) && (
            <div className="my-20 flex h-full w-full items-center justify-center">
              <Icon className="lucide--loader-2 animate-spin duration-700" />
            </div>
          )}
          {doc && subsetId && (
            <>
              {/* Document Viewer Section */}
              <div className="-mb-8 flex-1 overflow-hidden">
                <div className="relative h-full">
                  <PDFViewer
                    docId={docId}
                    highlights={[]}
                    hideFeatureButtons={true}
                    hideSnippingTool={true}
                    fileName={doc.file?.name}
                    closeViewer={onClose}
                  />
                </div>
              </div>

              <div className="z-10">
                <DocumentTabs
                  tabs={[{ id: docId, label: doc.file?.name ?? '' }]}
                  selectedId={docId}
                  onSelect={() => {}}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
